exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".upload-file .el-upload-dragger{width:500px}", "", {"version":3,"sources":["/workspace/src/views/question-review/components/UploadFile/src/main.vue"],"names":[],"mappings":"AACA,gCAAgC,WAAW,CAC1C","file":"main.vue","sourcesContent":["\n.upload-file .el-upload-dragger{width:500px\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6d9f3e02","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/question-review/components/UploadFile/src/main.vue
// module id = 2257
// module chunks = 5 34